import axiosInstance from "../Utils/axiosInstance";
import { backendbaseUrl } from "../Utils/baseUrl";

export const fetchCurrentUserData = async () => {
    const response = await axiosInstance.get(`${backendbaseUrl}/users/user-details/`);
    return response.data;
};  